module.exports = __webpack_public_path__ + "static/asthmagram-prototype-5cb739abdff424f0c730c042a6c39f55.jpg";